import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { isAuthenticated } from '../../gallery/selectors'
import { deauthenticate } from '../actions'
import MenuComponent from './MenuComponent'

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
})

const mapDispatchToProps = (dispatch, { router }) => ({
  handleLogout: () => {
    dispatch(deauthenticate(router))
  },
})

const Menu = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MenuComponent)
)

export default Menu



// WEBPACK FOOTER //
// ./src/gallery/components/Menu.js